import * as types from "../actions/types/bulkPayments.types";

const initialState = {
    makeBulkTransferState: "idle",
    bulkList: [],
    multipleTransfersList: [],
    verifyAccState: "initial",
    verifyAccountData: {
        beneficiaryAccountNumber: "",
        beneficiaryBankCode: null,
        beneficiaryCustomerID: 0,
        beneficiaryName: "",
        isSuccessful: false,
        message: "",
        nameEnquiryID: 0,
        responseCode: "",
        senderAccountNumber: null,
        senderName: null,
        sessionID: "",
        transferCharge: 0,
    },
    selectedBeneficiaryData: {},
    beneficiaryBankData: {
        bankCode: "",
        bankName: "",
        iconUrl: "",
        accountNumber: "",
    },
    viewSendMoneyAccount: false,
    bulkPaymentType: "",
    multipleTransfersNote: {
        skipNote: "",
        noteValue: "",
    },
    proceeBulkNameInquiryState: "idle",
    nameInquiryList: [],
    editMultipleTransferItem: false,
    editObjInfo: {},
    beneficiaryInfo: {
        beneficiaryAccountNumber: "",
        beneficiaryAmount: null,
        beneficiaryBank: null,
        beneficiaryBankCode: null,
        beneficiaryCustomerID: null,
        beneficiaryIndex: null,
        beneficiaryName: null,
        sessionID: null,
    },
};

export const bulkPaymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ADD_BULK_LIST:
            return {
                ...state,
                bulkList: action.payload,
            };
        case types.ADD_MULTIPLE_TRANSFERS_LIST:
            const isEditMode = state.editMultipleTransferItem;
            const accountIsAlreadyPresent = state.multipleTransfersList.some(
                    (multipleList) => multipleList.accountNumber === action.payload.accountNumber);

            if (isEditMode || accountIsAlreadyPresent) {
                const transferItemIndex = state.multipleTransfersList
                    .map(({ accountNumber }) => accountNumber)
                    .indexOf(action.payload.accountNumber);

                const transferList = [...state.multipleTransfersList];

                const editedTransferItem = {
                    ...action.payload,
                };

                transferList[transferItemIndex] = editedTransferItem;

                return {
                    ...state,
                    multipleTransfersList: [...transferList],
                };
            }

            return {
                ...state,
                multipleTransfersList: [...state.multipleTransfersList, action.payload],
            };
        // }
        case types.VIEW_SEND_MONEY_ACCOUNT:
            return {
                ...state,
                viewSendMoneyAccount: true,
            };
        case types.HIDE_SEND_MONEY_ACCOUNT:
            return {
                ...state,
                viewSendMoneyAccount: false,
            };
        case types.VERIFY_ACCOUNT_STARTED:
            return {
                ...state,
                verifyAccState: "loading",
            };
        case types.VERIFY_ACCOUNT_SUCCEDEED:
            return {
                ...state,
                verifyAccState: "success",
                verifyAccountData: {
                    ...state.verifyAccountData,
                    ...action.payload,
                    beneficiaryAccountNumber: action.payload.beneficiaryAccountNumber,
                    beneficiaryBankCode: action.payload.beneficiaryBankCode,
                    beneficiaryCustomerID: action.payload.beneficiaryCustomerID,
                    beneficiaryName: action.payload.beneficiaryName,
                    isSuccessful: action.payload.isSuccessful,
                    message: action.payload.message,
                    nameEnquiryID: action.payload.nameEnquiryID,
                    responseCode: action.payload.responseCode,
                    senderAccountNumber: action.payload.senderAccountNumber,
                    senderName: action.payloadsenderName,
                    sessionID: action.payload.sessionID,
                    transferCharge: action.payload.transferCharge,
                },
                verifyMessage: action.payload.message,
                beneficiaryInfo: {
                    ...state.beneficiaryInfo,
                    beneficiaryCustomerID: action.payload.beneficiaryCustomerID,
                    beneficiaryIndex: action.payload.beneficiaryIndex,
                    beneficiaryName: action.payload.beneficiaryName,
                    sessionID: action.payload.sessionID,
                },
            };
        case types.VERIFY_ACCOUNT_FAILED:
            return {
                ...state,
                verifyAccState: "failed",
                verifyMessage: action.payload,
            };
        case types.RESET_BENEFICIARY_STATE:
            return {
                ...state,
                verifyAccState: "idle",
                verifyAccountData: {},
                verifyMessage: "",
                selectedBeneficiaryData: {},
                beneficiaryInfo: {
                    ...state.beneficiaryInfo,
                    beneficiaryAccountNumber: "",
                    beneficiaryAmount: null,
                    beneficiaryCustomerID: null,
                    beneficiaryIndex: null,
                    beneficiaryName: null,
                    sessionID: null,
                },
            };
        case types.SELECTED_BANK_DATA_BULK:
            return {
                ...state,
                beneficiaryInfo: {
                    ...state.beneficiaryInfo,
                    beneficiaryBank: action.payload.bankName,
                    beneficiaryBankCode: action.payload.bankCode,
                    iconUrl: action.payload.iconUrl,
                },
            };
        case types.RESET_PAYMENTS:
            return {
                ...state,
                processTransferState: "initial",
                viewSendMoneyAccount: false,
                verifyAccState: "initial",
                verifyAccountData: {},
                beneficiaryBankData: {
                    ...state.beneficiaryBankData,
                    bankCode: "",
                    bankName: "",
                    iconUrl: "",
                    accountNumber: "",
                },
                selectedBeneficiaryData: {},
                bulkPaymentType: "",
            };
        case types.SET_BENEFICIARY_DATA:
            return {
                ...state,
                // selectedBeneficiaryData: action.payload,
                beneficiaryInfo: {
                    ...state.beneficiaryInfo,
                    beneficiaryCustomerID: action.payload.beneficiaryCustomerID,
                    beneficiaryAccountNumber: action.payload.accountNumber,
                    iconUrl: action.payload.iconUrl,
                    beneficiaryBankCode: action.payload.bankCode,
                    beneficiaryName: action.payload.beneficiaryName,
                    beneficiaryBank: action.payload.bankName,
                },
            };
        case types.SET_BULK_PAYMENT_TYPE:
            return {
                ...state,
                bulkPaymentType: action.payload,
            };
        case types.MAKE_BULK_PAYMENT_STARTED:
            return {
                ...state,
                makeBulkTransferState: "loading",
            };
        case types.MAKE_BULK_PAYMENT_SUCCEDED:
            return {
                ...state,
                makeBulkTransferState: "success",
            };
        case types.MAKE_BULK_PAYMENT_FAILED:
            return {
                ...state,
                makeBulkTransferState: "failed",
            };
        case types.SKIP_MULTIPLE_TRANSFER_NOTE:
            return {
                ...state,
                multipleTransfersNote: {
                    ...state.multipleTransfersNote,
                    skipNote: action.payload,
                },
            };
        case types.ADD_MULTIPLE_TRANSFER_NOTE:
            return {
                ...state,
                multipleTransfersNote: {
                    ...state.multipleTransfersNote,
                    noteValue: action.payload,
                },
            };
        case types.BULK_PAYMENT_NAME_INQUIRY_STARTED:
            return {
                ...state,
                proceeBulkNameInquiryState: "loading",
            };
        case types.BULK_PAYMENT_NAME_INQUIRY_SUCCEDED:
            return {
                ...state,
                proceeBulkNameInquiryState: "success",
                nameInquiryList: action.payload,
            };
        case types.BULK_PAYMENT_NAME_INQUIRY_FAILED:
            return {
                ...state,
                proceeBulkNameInquiryState: "failed",
            };
        case types.DELETE_SINGLE_MULTIPLE_TRANSFER:
            const updatedList = state.multipleTransfersList.filter(
                (item, index) => index !== action.payload,
            );
            return {
                ...state,
                multipleTransfersList: updatedList,
            };
        case types.ON_EDIT_MULTIPLE_TRANSFER_ITEM:
            return {
                ...state,
                editMultipleTransferItem: action.payload.booleanValue,
                editObjInfo: { ...state.editObjInfo, ...action.payload.data },
            };
        case types.RESET_TRANSFER_LIST:
            return {
                ...state,
                multipleTransfersList: [],
                multipleTransfersNote: {
                    skipNote: "",
                    noteValue: "",
                },
            };
        case types.RESET_UPLOAD_CSV_LIST:
            return {
                ...state,
                nameInquiryList: [],
                bulkList: [],
                multipleTransfersNote: {
                    skipNote: "",
                    noteValue: "",
                },
            };
        case types.EDIT_SINGLE_MULTIPLE_TRANSFER:
            const itemIndex = state.multipleTransfersList.findIndex(
                (item, index) => index === action.payload.index,
            );
            let updatedListOnEdit = [...state.multipleTransfersList];
            updatedListOnEdit[itemIndex] = {
                ...updatedListOnEdit[itemIndex],
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                designation: action.payload.designation,
                dateOfBirth: action.payload.dateOfBirth,
                phoneNumber: action.payload.phoneNumber,
                roleID: action.payload.roleID,
                status: action.payload.status,
                address: action.payload.address,
                id: action.payload.id,
                smeprofileid: action.payload.smeprofileid,
                userid: action.payload.userid,
            };
            return {
                ...state,
                multipleTransfersList: updatedListOnEdit,
            };
        case types.PROCESS_BULK_TRANSFER_STARTED:
            return {
                ...state,
                processBulkTransferState: "loading",
            };
 
        case types.SINGLE_BULK_PAYMENT_NAME_INQUIRY_STARTED:
            return {
                ...state,
                proceeBulkNameInquiryState: "loading",
            };
        case types.SINGLE_BULK_PAYMENT_NAME_INQUIRY_SUCCEDED:
            return {
                ...state,
                proceeBulkNameInquiryState: "success",
            };
        case types.SINGLE_BULK_PAYMENT_NAME_INQUIRY_FAILED:
            return {
                ...state,
                proceeBulkNameInquiryState: "failed",
            };
        case types.UPDATE_NAME_INQUIRY_LIST:
            return {
                ...state,
                nameInquiryList: action.payload,
            };
        case types.DELETE_BULK_PAYMENT_ITEM:
            return {
                ...state,
                nameInquiryList: action.payload,
            };
        default:
            return state;
    }
};
